import {Module} from "vuex"
import type { IRootState } from "../../store/root-state"
import {SecondaryCustService} from "./secondary-cust-service"
import {ISecondaryCustDef} from "./secondary-cust-models"
import * as R from "ramda"

// Import service locator functions
import {
  getSecondaryCustService,
} from "../../common/services/service-registry";

export interface ISecondaryCustStoreState {
    secondaryCustDefs: ISecondaryCustDef[];
}


export enum SECONDARY_CUST_STORE_CONST {
    SECONDARY_CUST_CONST_MODULE_NAME =  "SECONDARY_CUST_CONST_MODULE_NAME",

    // <MUTATIONS>
    SECONDARY_CUST_MUTATIONS_SECONDARIES_SET = "SECONDARY_CUST_MUTATIONS_SECONDARIES_SET",
    // </MUTATIONS>

    // <GETTERS>
    SECONDARY_CUST_GETTER_ANY_ATHLETE_ITEMS = "SECONDARY_CUST_GETTER_ANY_ATHLETE_ITEMS"
    // </GETTERS>
}

const mutations = {
    [ SECONDARY_CUST_STORE_CONST.SECONDARY_CUST_MUTATIONS_SECONDARIES_SET ](state: ISecondaryCustStoreState, secondaryDefs: ISecondaryCustDef[]) {
        state.secondaryCustDefs = R.clone(secondaryDefs);
    }
}

const getters = {
    [ SECONDARY_CUST_STORE_CONST.SECONDARY_CUST_GETTER_ANY_ATHLETE_ITEMS ](state: ISecondaryCustStoreState) {
        return getSecondaryCustService().anyAthleteItems(state.secondaryCustDefs);
    }
};

const actions = {};

/**
 * Default state factory for secondary cust store
 * This replaces the service call that was causing the circular dependency
 */
function getDefaultSecondaryCustState(): ISecondaryCustStoreState {
  return {
    secondaryCustDefs: []
  };
}

/**
 * Create secondary cust store module with dependency injection
 */
export function createSecondaryCustStore(serviceContainer: any): Module<ISecondaryCustStoreState, IRootState> {
  return {
    namespaced: true,
    state: getDefaultSecondaryCustState(),
    mutations,
    getters,
    actions,
  };
}

// Legacy export for backward compatibility (will be removed after full migration)
export const secondaryCustStore: Module<ISecondaryCustStoreState, IRootState> = {
  namespaced: true,
  state: getDefaultSecondaryCustState(),
  mutations,
  getters,
  actions
};
